export const CHECKOUT_URL = 'https://clear-en.impultienda.ar/checkout/'

export const images = {
  mockup: 'https://cdn.magicpatterns.com/uploads/f8wyRDfLiv47a22vi3fGw5/MOCKUP_CLEAN-EN.png',
  creator: 'https://cdn.magicpatterns.com/uploads/8kdw9uqk6VbB9PiBjThD9X/VALERIA_MONTES_-_BIOMECANICA.png',
}

export const heroBullets = [
  'Six comprehensive digital volumes',
  'Five practical planning bonuses',
  'Structured worksheets and checklists',
  'Case review and treatment-planning frameworks',
  'Instant digital access after purchase',
  'One-time payment of just $27 USD',
]

export const valueStack = [
  { label: 'Volume 1 — Case Assessment & Clinical Foundations', value: 37 },
  { label: 'Volume 2 — Clinical Findings to Treatment Objectives', value: 37 },
  { label: 'Volume 3 — Biomechanics & Movement Considerations', value: 37 },
  { label: 'Volume 4 — Treatment Sequencing & Digital Planning Review', value: 37 },
  { label: 'Volume 5 — Tracking, Refinement & Reassessment', value: 37 },
  { label: 'Volume 6 — Complete Case Review Blueprint', value: 37 },
  { label: 'Bonus #1 — Clear Aligner Case Analysis Cards™', value: 37 },
  { label: 'Bonus #2 — Case Mapping Workbook™', value: 27 },
  { label: 'Bonus #3 — Biomechanics Review Checklist™', value: 29 },
  { label: 'Bonus #4 — Troubleshooting Casebook™', value: 27 },
  { label: 'Bonus #5 — One-Page Case Review Template™', value: 27 },
]

export const offerChecks = [
  'One-time payment',
  'Digital educational materials',
  'Six comprehensive volumes',
  'Five practical bonuses',
  'No recurring subscription fee for this offer',
]

export const collectionChecks = [
  '6 comprehensive digital volumes',
  'Structured educational frameworks',
  'Practical worksheets and checklists',
  'Case-review templates',
  'Treatment-planning organization tools',
  'A coordinated six-stage workflow',
]

export const finalChecks = [
  '6 comprehensive educational volumes',
  '5 practical bonuses',
  'Case-review worksheets and checklists',
  'Treatment-planning organization frameworks',
  'A reusable six-stage review structure',
]

export const recentBuyers = [
  { name: 'Dra. María Fernanda', country: 'Mexico' },
  { name: 'Dr. Andrés Camilo', country: 'Colombia' },
  { name: 'Dra. Lucía', country: 'Argentina' },
  { name: 'Dr. Javier', country: 'Spain' },
  { name: 'Dra. Valentina', country: 'Chile' },
  { name: 'Dr. Diego', country: 'Peru' },
  { name: 'Dra. Camila', country: 'Uruguay' },
  { name: 'Dr. Mateo', country: 'Ecuador' },
  { name: 'Dra. Sofía', country: 'Costa Rica' },
  { name: 'Dr. Alejandro', country: 'Guatemala' },
  { name: 'Dra. Daniela', country: 'Dominican Republic' },
  { name: 'Dr. Ricardo', country: 'Panama' },
  { name: 'Dra. Gabriela', country: 'Venezuela' },
  { name: 'Dr. Sebastián', country: 'Paraguay' },
  { name: 'Dra. Isabela', country: 'Bolivia' },
  { name: 'Dr. Martín', country: 'Puerto Rico' },
]
